module.exports = __webpack_public_path__ + "img/contact.203522f3.jpg";